import { getApi, getApiWithParam, postApi, putApi } from "./api";

// export const GetAllOrder = async (userId) => {
//     return await getApi(
//         `/Order/GetOrder/${userId}`
//     );
// };
export const GetAllOrder = async (
  userId,
  startDate,
  endDate
) => {
  return await getApiWithParam("/Order/GetOrder/", {
    params: {
      userId,
      startDate,
      endDate,
    },
  });
};

export const GetPincodeNotSrvsOrders = async () => {
    return await getApi(
        `/Order/GetPincodeNotSrvsOrders`
    );
};
export const GetAdminOrderByStatusAndDate = async (
  userId,
  statusId,
  startDate,
  endDate
) => {
  return await getApiWithParam("/Order/GetAdminOrderByStatusAndDate/", {
    params: {
      userId,
      statusId,
      startDate,
      endDate,
    },
  });
};
export const GetOrderByStatusIdAndDate = async (
  userId,
  statusId,
  startDate,
  endDate,
  ndrStatus = false
) => {
  return await getApiWithParam("/Order/GetOrderByStatusAndDate/", {
    params: {
      userId,
      statusId,
      startDate,
      endDate,
      ndrStatus,
    },
  });
};
export const addOrder = async (orderData) => {
    try {
        const response = await postApi(
            "/Order/OrderAdd",
            orderData
        );
        return response;

    } catch (error) {
        console(error);
        throw error.response?.data || error.message;
    }
};
export const GetDisease = async () => {
    return await getApi(
        `/Order/GetDiseases`
    );
};
export const GetState = async () => {
    return await getApi(
        `/Order/GetStates`
    );
};
export const GetProduct = async () => {
    return await getApi(
        `/Inventory/getactiveproduct`
    );
};

export const GetProductsPrice = async (productId) => {
    return await getApi(
        `/Order/GetProductsPrice/${productId}`
    );
};

export const addReOrder = async (orderData) => {
    try {
        const response = await postApi(
            "/Order/ReOrderAdd",orderData
        );
        return response;

    } catch (error) {
        console(error);
        throw error.response?.data || error.message;
    }
};

export const GetOrderByMobile = async (mobile) => {
    return await getApi(`/Order/GetOrdersByMobile/${mobile}`);
};

export const GetAssignFollowUpOrders = async () => {
    return await getApi(`/Order/GetAssignFollowUpOrders`);
};

export const AssignOrders = async () => {
    try {
        const response = await postApi("/Order/AssignOrders");
        return response;
    } catch (error) {
        console.error(error);
        throw error.response?.data || error.message;
    }
};
export const markAsDelivered = async (orderId) => {
  try {
    const response = await putApi(
      `/Order/MarkAsDelivered/${orderId}`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const UpdateOrder = async (id, data) => {
    try {
        return await putApi(`/Order/UpdateOrder/${id}`, data);
    } catch (error) {
        console.error(error);
        throw error.response?.data || error.message;
    }
};